import { render } from "./onboarding-availability.vue?vue&type=template&id=68da47e0"
import script from "./onboarding-availability.vue?vue&type=script&lang=js"
export * from "./onboarding-availability.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__